import React from 'react';

export default {
  routes: [
    //  VIP服务页
    {
      exact: true,
      path: '/vip',
      isDynamic: true,
      ID: 'prod003',
      component: React.lazy(
          () => import(/* webpackChunkName: "home",webpackPrefetch: true */ '@/pages/Home'),
      ),
    },
    {
      exact: true,
      path: '/redirect',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/Redirect'),
      ),
    },
    {
      exact: true,
      path: '/authorization',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/Authorization'),
      ),
    },
    {
      exact: true,
      path: '/env',
      isDynamic: true,
      component: React.lazy(
          () => import( /* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/Env'),
      ),
    },
    {
      exact: true,
      path: '/o2n',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/o2n'),
      ),
    },
    {
      exact: true,
      path: '/debug',
      isDynamic: true,
      component: React.lazy(
          () => import( /* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/Debug'),
      ),
    },
    {
      exact: true,
      path: '/first-gear/stream',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/first-gear/stream'),
      ),
    },
    {
      exact: true,
      path: '/first-gear/stock-detail',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/first-gear/stock-detail'),
      ),
    },
    {
      exact: true,
      path: '/first-gear/top-list',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/first-gear/top-list'),
      ),
    },
    {
      exact: true,
      path: '/first-gear/stock',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/first-gear/stock'),
      ),
    },
    {
      exact: true,
      path: '/first-gear/recent-stock',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/first-gear/recent-stock'),
      ),
    },
     {
      exact: true,
      path: '/first-gear/hotspot-scout-detail',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/first-gear/hotspot-scout-detail'),
      ),
    },

    {
      exact: true,
      path: '/second-gear/relevant',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/second-gear/relevant'),
      ),
    },
    {
      exact: true,
      path: '/second-gear/dynamic',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/second-gear/dynamic'),
      ),
    },
    {
      exact: true,
      path: '/second-gear/shares-pool',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/second-gear/shares-pool'),
      ),
    },
    {
      exact: true,
      path: '/artical-detail',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/artical-detail'),
      ),
    },
    {
      exact: true,
      path: '/course/:seriesNumber',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/course'),
      ),
    },
    {
      exact: true,
      path: '/no-access',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/no-access'),
      ),
    },
    {
      exact: true,
      path: '/warn',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/warn-page'),
      ),
    },
    //  实时解盘
    {
      exact: true,
      path: '/free-stream',
      isDynamic: true,
      ID: 'prod002',
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/free-stream'),
      ),
    },
    {
      exact: true,
      path: '/userCenter',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "user-center",webpackPrefetch: true */ '@/pages/user-center'),
      ),
    },
    {
      exact: true,
      path: '/userCenter/broker-list',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "my-order-detail",webpackPrefetch: true */ '@/pages/user-center/broker-list'),
      ),
    },
    // 我的订单
    {
      exact: true,
      path: '/userCenter/my-order',
      isDynamic: true,
      ID: 'prod006',
      component: React.lazy(
          () => import(/* webpackChunkName: "my-order",webpackPrefetch: true */ '@/pages/user-center/my-order'),
      ),
    },
    {
      exact: true,
      path: '/userCenter/my-order02',
      isDynamic: true,
      ID: 'prod006',
      component: React.lazy(
          () => import(/* webpackChunkName: "my-order",webpackPrefetch: true */ '@/pages/user-center/my-order'),
      ),
    },
    {
      exact: true,
      path: '/userCenter/my-order-detail',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "my-order-detail",webpackPrefetch: true */ '@/pages/user-center/my-order-detail'),
      ),
    },
    //  我的个人资料
    {
      exact: true,
      path: '/userCenter/my-address',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "my-order-detail",webpackPrefetch: true */ '@/pages/user-center/my-address'),
      ),
    },
    {
      exact: true,
      path: '/userCenter/my-address/success',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "my-order-detail",webpackPrefetch: true */ '@/pages/user-center/my-address/component'),
      ),
    },
    {
      exact: true,
      path: '/userCenter/my-prize',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "my-order-detail",webpackPrefetch: true */ '@/pages/user-center/my-prize'),
      ),
    },
    {
      exact: true,
      path: '/userCenter/my-prize-detail',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "my-order-detail",webpackPrefetch: true */ '@/pages/user-center/my-prize-detail'),
      ),
    },
    {
      exact: true,
      path: '/userCenter/my-prize/giftPrizeDetail',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "my-order-detail",webpackPrefetch: true */ '@/pages/user-center/my-prize/components/giftPrize/components/giftPrizeDetail'),
      ),
    },
    {
      exact: true,
      path: '/giftsDetail/:introduceId',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "my-order-detail",webpackPrefetch: true */ '@/pages/user-center/my-prize/components/giftPrize/components/gifts-detail'),
      ),
    },
    {
      exact: true,
      path: '/userCenter/my-info',
      isDynamic: true,
      ID: 'prod005',
      component: React.lazy(
          () => import(/* webpackChunkName: "my-info",webpackPrefetch: true */ '@/pages/user-center/my-info'),
      ),
    },
    {
      exact: true,
      path: '/userCenter/my-info/wx-info',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "my-info",webpackPrefetch: true */ '@/pages/user-center/my-info/wx-info'),
      ),
    },
    {
      exact: true,
      path: '/userCenter/my-info/wx-unbind-result',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "my-info",webpackPrefetch: true */ '@/pages/user-center/my-info/wx-unbind-result'),
      ),
    },
    {
      exact: true,
      path: '/userCenter/my-agreement',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/user-center/my-agreement'),
      ),
    },
    // 我的测评
    {
      exact: true,
      path: '/userCenter/my-assessment',
      isDynamic: true,
      ID: 'prod009',
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/user-center/my-assessment'),
      ),
    },
    // 我的问卷列表
    {
      exact: true,
      path: '/userCenter/my-feedback-list',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/user-center/my-feedback-list'),
      ),
    },
    // 帮助与反馈
    {
      exact: true,
      path: '/userCenter/feedback',
      isDynamic: true,
      ID: 'prod008',
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/user-center/components/Feedback'),
      ),
    },
      //app帮助与反馈
    {
      exact: true,
      path: '/app/feedback',
      isDynamic: true,
      ID: 'prod008',
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/app/feedback'),
      ),
    },
    {
      exact: true,
      path: '/app/feedback/details',
      isDynamic: true,
      ID: 'prod008',
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/app/feedback-detail'),
      ),
    },
    {
      exact:true,
      path:'/app/complaints-and-suggestions',
      isDynamic: true,
      ID: 'prod008',
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/app/complaints-and-suggestions'),
      ),
    },
    //个人信息收集清单
    {
      exact:true,
      path:'/app/info-collect-list/index',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/app/info-collect-list/index'),
      ),
    },
      //用户信息
    {
      exact:true,
      path:'/app/info-collect-list/user-info',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/app/info-collect-list/user-info'),
      ),
    },
      //使用过程信息
    {
      exact:true,
      path:'/app/info-collect-list/user-process-info',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/app/info-collect-list/user-process-info'),
      ),
    },
      //设备信息
    {
      exact:true,
      path:'/app/info-collect-list/device-info',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/app/info-collect-list/device-info'),
      ),
    },
      //应用权限说明
    {
      exact:true,
      path:'/app/app-permission',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/app/app-permission'),
      ),
    },
    //   用户注销协议
    {
      exact: true,
      path: '/app/cancellation/agreement',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page2",webpackPrefetch: true */ '@/pages/app/user-cancellation-agreement'),
      ),
    },
    {
      exact: true,
      path: '/userCenter/feedback/details',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/user-center/components/FeedbackDetails'),
      ),
    },
    {
      exact: true,
      path: '/userCenter/real-name',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/user-center/real-name'),
      ),
    },
    // 优惠券
    {
      exact: true,
      path: '/userCenter/coupon',
      isDynamic: true,
      ID: 'prod007',
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/user-center/coupon'),
      ),
    },
    {
      exact: true,
      path: '/userCenter/my-invoice',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/user-center/my-invoice'),
      ),
    },
    //  首页
    {
      exact: true,
      path: '/information',
      ID: 'prod001',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/information'),
      ),
    },
    {
      exact: true,
      path: '/information/detail',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/information-detail'),
      ),
    },
    {
      exact: true,
      path: '/information/stream-detail',
      isDynamic: true,
      ID: 'prod014',
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/information/stream-detail'),
      ),
    },
    {
      exact: true,
      path: '/information/important-news-detail',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/information/important-news-detail'),
      ),
    },
    {
      exact: true,
      path: '/information/native-video-play',
      isDynamic: true,
      ID: 'IPvediolink',
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/information/native-video-play'),
      ),
    },
    //  每日股评
    {
      exact: true,
      path: '/daily-stock',
      isDynamic: true,
      ID: 'prod004',
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/daily-stock'),
      ),
    },
    {
      exact: true,
      path: '/daily-stock-detail',
      isDynamic: true,
      ID: 'prod016',
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/daily-stock-detail'),
      ),
    },
    //  积分主页
    {
      exact: true,
      path: '/integral',
      isDynamic: true,
      ID: 'prod010',
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/integral'),
      ),
    },
    // 积分记录
    {
      exact: true,
      path: '/record',
      isDynamic: true,
      ID: 'prod012',
      component: React.lazy(
          () => import('@/pages/integral/components/record'),
      ),
    },
    //  积分规则
    {
      exact: true,
      path: '/rule',
      isDynamic: true,
      ID: 'prod013',
      component: React.lazy(
          () => import('@/pages/integral/components/rule'),
      ),
    },
    // 积分商城
    {
      exact: true,
      path: '/shop',
      isDynamic: true,
      ID: 'prod011',
      component: React.lazy(
          () => import('@/pages/integral/components/shop'),
      ),
    },
    {
      exact: true,
      path: '/free-quote',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/free-quotes'),
      ),
    },
    {
      exact: true,
      path: '/quote-search',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/quote-search'),
      ),
    },
    {
      exact: true,
      path: '/stock-detail',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/stock-detail'),
      ),
    },
    {
      exact: true,
      path: '/edit-optional',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/edit-optional'),
      ),
    },
    {
      exact: true,
      path: '/all-announce',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/quotes-info/components/announcement/all-announce'),
      ),
    },
    {
      exact: true,
      path: '/customized-stock/stock-price',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/customized-stock/stock-price'),
      ),
    },
    // 内容主详情
    {
      exact: true,
      path: '/content-master-detail',
      isDynamic: true,
      component: React.lazy(
          () => import('@/pages/content-master-detail'),
      ),
    },
    {
      exact: true,
      path: '/video-detail/:videoId',
      isDynamic: true,
      ID: 'prod015',
      component: React.lazy(
          () => import('@/pages/video-detail'),
      ),
    },
    {
      exact: true,
      path: '/video/warn',
      isDynamic: true,
      component: React.lazy(
          () => import('@/pages/video-detail/warn'),
      ),
    },
    {
      exact: true,
      path: '/complaints-and-suggestions',
      isDynamic: true,
      component: React.lazy(
          () => import('@/pages/complaints-and-suggestions'),
      ),
    },
    {
      exact: true,
      path: '/complaints-and-suggestions/step2',
      isDynamic: true,
      component: React.lazy(
          () => import('@/pages/complaints-and-suggestions/components/step2'),
      ),
    },
    {
      exact: true,
      path: '/complaints-and-suggestions/step3',
      isDynamic: true,
      component: React.lazy(
          () => import('@/pages/complaints-and-suggestions/components/step3'),
      ),
    },
    {
      exact: true,
      path: '/complaints-and-suggestions/step4',
      isDynamic: true,
      component: React.lazy(
          () => import('@/pages/complaints-and-suggestions/components/step4'),
      ),
    },
    {
      exact: true,
      path: '/complaints-and-suggestions/message',
      isDynamic: true,
      component: React.lazy(
          () => import('@/pages/complaints-and-suggestions/components/message'),
      ),
    },
    //  实战跟投（新）
    {
      exact: true,
      path: '/teach',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/teach'),
      ),
    },
    //  案例股池详情
    {
      exact: true,
      path: '/teach/detail',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/teach-detail'),
      ),
    },
    //  三档股池
    {
      exact: true,
      path: '/third-stock-pool',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/Home/component/third/component/third-stock-pool'),
      ),
    },
    //  三档文章栏目
    {
      exact: true,
      path: '/third-article',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/Home/component/third/component/third-article'),
      ),
    },
    //  三档历史动态
    {
      exact: true,
      path: '/third-history-list',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "page1",webpackPrefetch: true */ '@/pages/Home/component/third/component/history-list'),
      ),
    },
    {
      exact: true,
      path: '/short-invalid',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/short-invalid'),
      ),
    },
    {
      exact: true,
      path: '/user-center/edit-nickname',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/user-center/edit-nickname'),
      ),
    },
    {
      exact: true,
      path: '/user-center/edit-avatar',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/user-center/edit-avatar'),
      ),
    },
    {
      exact: true,
      path: '/use-guide',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/use-guide'),
      ),
    },

    //   每日题材挖掘
    {
      exact: true,
      path: '/daily-topic-explorer/list',
      isDynamic: true,
      ID: 'prod118',
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/daily-topic-explorer/list'),
      ),
    },
    //   每日题材详情
    {
      exact: true,
      path: '/daily-topic-explorer/detail',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/daily-topic-explorer/detail'),
      ),
    },
    //  每日短线捕手（与每日题材挖掘一致）
    {
      exact: true,
      path: '/daily-short-term-trader/list',
      isDynamic: true,
      ID: 'prod119',
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/daily-short-term-trader/list'),
      ),
    },
    //   每日短线捕手详情（与每日题材详情一致）
    {
      exact: true,
      path: '/daily-short-term-trader/detail',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/daily-short-term-trader/detail'),
      ),
    },
    //   热股竞价
    {
      exact: true,
      path: '/call-auction-stock/home',
      isDynamic: true,
      ID: 'prod120',
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/call-auction-stock/home'),
      ),
    },
    //   热股竞价-短链接
    {
      exact: true,
      path: '/call-auction-stock-short/home',
      isDynamic: true,
      ID: 'prod120',
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/call-auction-stock/short-home'),
      ),
    },
    //   热股竞价小程序
    {
      exact: true,
      path: '/call-auction-stock-mina/home',
      isDynamic: true,
      ID: 'prod120',
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/call-auction-stock/home'),
      ),
    },
    //   链接失效
    {
      exact: true,
      path: '/link-invalid',
      isDynamic: true,
      ID: 'prod120',
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/call-auction-stock/link-invalid'),
      ),
    },
    //  热股竞价往期数据
    {
      exact: true,
      path: '/call-auction-stock/history-list',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/call-auction-stock/history-list'),
      ),
    },
    {
      exact: true,
      path: '/mini-program/stock-detail',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/mini-program/stock-detail'),
      ),
    },
    {
      exact: true,
      path: '/mini-program/index-detail',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/mini-program/index-detail'),
      ),
    },
    {
      exact: true,
      path: '/mini-program/six-pulse-sword',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/mini-program/six-pulse-sword'),
      ),
    },
    {
      exact: true,
      path: '/mini-program/constituent-stocks',
      isDynamic: true,
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/mini-program/constituent-stocks'),
      ),
    },
    {
      exact: true,
      path: '/marketing-article/:number',
      isDynamic: true,
      ID: 'prod124',
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/marketing-article'),
      ),
    },
    {
      exact: true,
      path: '/first-gear/hotspot-scout',
      isDynamic: true,
      ID: 'prod124',
      component: React.lazy(
          () => import(/* webpackChunkName: "Redirect",webpackPrefetch: true */ '@/pages/first-gear/hotspot-scout'),
      ),
    },
  ],
};
